export default __webpack_public_path__ + "static/media/bitcoin.61ec0735.svg";